import { RoleLookup } from './role-lookup.interface';
import { GoabButtonType, GoabIconType } from '@abgov/angular-components';

export class UserNavigationItem {
  text: string;
  action: string;
  icon?: GoabIconType;
  url?: string;
  roleAccess?: RoleLookup[];
  newWindow?: boolean;
  goaOnly?: boolean;
  keycloakOnly?: boolean;
  albertaCaOnly?: boolean;
}

export class UserNavigation {
  type: GoabButtonType;
  text: string;
  menuItems: UserNavigationItem[];
  logoutUrl?: string;
  partnerLogoutUrl?: string;
}
